function b(u,c){let s=c;const e=[];return{dispatch(t){s=u(s,t),e.forEach(r=>r())},subscribe(t){e.push(t);let r=!0;return function(){if(!r)return;const n=e.indexOf(t);e.splice(n,1),r=!1}},getState(){return s}}}export{b as createStore};
//# sourceMappingURL=createStore.es.js.map
